module.exports = __webpack_public_path__ + "static/img/height.e5e41d5f.png";